/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Step_DownInputs */

const en_editor_step_down = /** @type {(inputs: Editor_Step_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Move down`)
};

const de_editor_step_down = /** @type {(inputs: Editor_Step_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nach unten`)
};

/**
* | output |
* | --- |
* | "Move down" |
*
* @param {Editor_Step_DownInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const editor_step_down = /** @type {((inputs?: Editor_Step_DownInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Step_DownInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_editor_step_down(inputs)
	return en_editor_step_down(inputs)
});